import {  asapScheduler } from 'rxjs';
import { Component, ElementRef, Input } from '@angular/core';
import { RevealContentStates } from '../reveal-content/reveal-content.constants';
import { MediaDrawerData } from './media-drawer.interface';
import { CommonModule } from '@angular/common';
import { CaptionedMediaGalleryComponent } from '../captioned-media-gallery/captioned-media-gallery.component';
import { PictureComponent } from '../picture/picture.component';
import { GenericTextComponent } from '../generic-text/generic-text.component';
import { RevealContentComponent } from '../reveal-content/reveal-content.component';
import { TutorialComponent } from '../tutorial/tutorial.component';
import { ComponentHeaderComponent } from '../component-header/component-header.component';


@Component({
    selector: 'finder-media-drawer',
    templateUrl: './media-drawer.component.html',
    styleUrls: ['./media-drawer.component.scss'],
    standalone: true,
    imports: [
        CaptionedMediaGalleryComponent,
        CommonModule,
        ComponentHeaderComponent,
        GenericTextComponent,
        PictureComponent,
        RevealContentComponent,
        TutorialComponent,
    ]
})
export class MediaDrawerComponent {
    @Input() data: MediaDrawerData;
    protected isExpanded = false;
    constructor( public elementRef: ElementRef,) {}

    revealContent(state: RevealContentStates) {
        this.isExpanded = state === RevealContentStates.LESS;

        if (this.isExpanded) {
            const elementReference = this.getElementReference();
            elementReference.querySelector('.collapsed-content').focus();
            elementReference.querySelector('.collapsed-content .captions .header-wrapper h3').tabIndex = 0;

            asapScheduler.schedule(() => {
                elementReference.querySelector('.collapsed-content .top-gallery-text .header-wrapper h3').tabIndex = 0;
            }, 10);
        }
    }

    /* istanbul ignore next */
    getElementReference() {
        return this.elementRef.nativeElement;
    }
}
